var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.module.form_style},[(_vm.loaded && _vm.module)?_c('module-form',{attrs:{"module-data":_vm.loadedModuleData,"row":_vm.row},on:{"saved":_vm.onSaved}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }